import { i18n } from '@/utils/i18n';

export const columns = {
    id : {
        show: true,
        title: i18n.t('message.n'),
        sortable: true,
        column: 'id'
    },
    position : {
        show: true,
        title: i18n.t('message.position'),
        sortable: true,
        column: 'position'
    },
    fix : {
      show: true,
      title: i18n.t('message.fix'),
      sortable: true,
      column: 'fix'
    },
    create_sanction_late : {
      show: true,
      title: i18n.t('message.create_sanction_late'),
      sortable: true,
      column: 'create_sanction_late'
    },
    created_at : {
        show: true,
        title: i18n.t('message.created_at'),
        sortable: true,
        column: 'created_at'
    },
    updated_at : {
        show: true,
        title: i18n.t('message.updated_at'),
        sortable: true,
        column: 'updated_at'
    },   
    settings : {
        show: true,
        title: i18n.t('message.settings'),
        sortable: false,
        column: 'settings'
    },

};
